import React from 'react';
import Form from 'antd/lib/form';
import InputNumber from 'antd/lib/input-number';
import 'antd/lib/input-number/style/index.css';
var InputRoutes = function (props) { return (React.createElement(Form.Item, { label: 'Number of routes/problems', extra: !props.isDisabled && 'Cannot be changed after round is created', colon: false }, props.form.getFieldDecorator("rounds[" + props.index + "][routeCount]", {
    initialValue: props.initialValue || 1,
    rules: [{
            required: true,
            message: 'You need routes!',
        }, {
            type: 'integer',
            message: 'Please use numbers',
        }],
})(React.createElement(InputNumber, { size: 'large', min: 1, max: 99, style: { width: '100%' }, disabled: props.isDisabled })))); };
export default InputRoutes;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormCategoryPage/FormRound/InputRoutes.tsx
// module id = 1179
// module chunks = 0